<div class="footer-bg">
    <div class="container-fluid">
        <!-- <div class="row pt-4 pb-3 footer-row-div">
            <div class="col-3" *ngFor="let eachOpt of footerOptions; let i=index;">
                <li class="footerOpt">
                    <a [title]="eachOpt.name" [href]="eachOpt.link">
                        <span class="footer-link-text" *ngIf="!isArabic">{{eachOpt.name}}</span>
                        <span class="footer-link-text" *ngIf="isArabic">{{eachOpt.arabicName}}</span>
                    </a>
                </li>
            </div>
        </div> -->

        <div class="row pt-2 pb-3 footerTxt">
            
            <a>
                <span *ngIf="!isArabic">
                    All rights reserved.
                    <!-- Ministry of Economy United Arab Emirates 2020 -->
                </span>
                <span *ngIf="isArabic">كل الحقوق محفوظة.
                </span>
                <!-- <span *ngIf="isArabic">
                    وزارة الاقتصاد الإمارات العربية المتحدة 2020
                </span> -->
            </a>
        </div>

    </div>

</div>